import { render, staticRenderFns } from "./jimuyun.vue?vue&type=template&id=b6aacdfa&"
import script from "./jimuyun.vue?vue&type=script&lang=js&"
export * from "./jimuyun.vue?vue&type=script&lang=js&"
import style0 from "./jimuyun.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports